import i18n from '@/plugins/i18n';

export const vendors = {
  GCP: {
    name: 'GCP',
    icon: 'gcp.png',
    title: i18n.global.t('aws.google-cloud-platform'),
    subtitile: i18n.global.t(
      'suite-of-cloud-computing-services-provided-by-google',
    ),
  },
  AWS: {
    name: 'AWS',
    icon: 'aws.png',
    title: i18n.global.t('aws.amazon-web-services'),
    subtitile: i18n.global.t(
      'aws.comprehensive-computing-platform-offered-by-amazon',
    ),
  },
  AZURE: {
    name: 'AZURE',
    icon: 'azure.png',
    title: i18n.global.t('aws.microsoft-azure'),
    subtitile: i18n.global.t(
      'aws.cloud-computing-service-by-microsoft-for-application-management',
    ),
  },
};
